import {LONG_API_TIMEOUT} from "@/pages/category";
import {DialogType} from "@/config";
import dayjs from "dayjs";
import {addEditDialog} from "@/pages/splitbillconfiguration/_actions";


export default {
  body: {
    type: 'crud',
    actions: {
      query: { api: { url: '/admin/order/share/rule/list', timeout: LONG_API_TIMEOUT } },
      // query: { api: '/admin/refundOrder/queryRefundOrderListPage' },
      add: {
        api: '/admin/order/share/rule/create',
        dialog: addEditDialog()
      },
      edit: {
        dialog: addEditDialog(DialogType.EDIT)
      },
      detail: {
        dialog: addEditDialog(DialogType.VIEW)
      },
      delete: {
        api: 'admin/coupon/modifyCouponStatus',
        payload: {},
        message: '撤回后，用户所有该类型优惠券立即失效。是否确定撤回？'
      }
    },
    search: {
      items: [
        { label: '无人车SN', type: 'input', prop: 'platform'},

      ]
    },
    toolbar: {
      items: [{ action: 'add' }]
    },

    table: {
      innerAttrs: { rowKey: 'raffCode' },
      operation: {
        width: 140,
        items: [
          { action: 'detail' },
          {
            action: 'edit',
            label: '编辑'
          },
          {
            action: 'delete'
          }
        ]
      },
      columns: [
        { label: '无人车SN', prop: 'taokouling', minWidth: 160 },
        { label: '是否直投', prop: 'platform', minWidth: 160},
        { label: '投放时间', prop: 'platform', minWidth: 160},
        { label: '投放区域', prop: 'platform', minWidth: 160},
        { label: '配送单价', prop: 'platform', minWidth: 160},
        { label: '收款方数量', prop: 'platform', minWidth: 160},
        { label: '总分账比例', prop: 'platform', minWidth: 160},
        { label: '已分账单量', prop: 'platform', minWidth: 160},
        { label: '分账开始时间', prop: 'platform', minWidth: 160},
        { label: '分账结束时间', prop: 'platform', minWidth: 160},
        { label: '状态', prop: 'platform', minWidth: 160},
      ]
    }
  }
}


